import type { UsersSelectOptionProps } from "./users-select-option.type";

import { Select } from "antd";

import { getUsersSelectOptionItem } from "../users-select.helper";

// TODO DEV-8551 `Option` is deprecated. Please use `options` instead.
// eslint-disable-next-line @typescript-eslint/no-deprecated
const { Option } = Select;

const UsersSelectOption = ({ option }: UsersSelectOptionProps) => {
  const { value, label } = getUsersSelectOptionItem(option);

  return (
    <Option key={value} value={value}>
      {label}
    </Option>
  );
};

export default UsersSelectOption;
